module.exports = __webpack_public_path__ + "static/media/assured_workload.fa64e86a.svg";